//Common views
export const USER_PROFILE = "common/userProfile";

//Dashboard views:
export const STATS = "dashboard/stats";
export const CODE_QR = "dashboard/codeQr";
export const PACKAGE = "dashboard/package";
export const USERS = "dashboard/users-activity";

//CMS views:
export const DISHES_CATEGORIES = "cms/dishesCategories";
export const ADDITIONS = "cms/additions";
export const TRANSLATIONS = "cms/translations";
export const PERSONALIZATION = "cms/personalization";